function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from "react";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import reaFoundations from "./foundations";
import CssReset from "./CssReset";
import { mapObject } from "./utils";
import { paletteHelper } from "../../utils";
import ToastProvider from "../Toast/ToastProvider";
import PortalProvider from "../../private/Portal/PortalProvider";
var makeCssVariables = (tokens, prefix) => {
  var tokenKeys = Object.keys(tokens);
  return tokenKeys.map(key => "--ck-" + prefix + key + ": " + tokens[key] + ";");
};
var makePalette = (palette, mode) => {
  var paletteKeys = Object.keys(palette);
  return paletteKeys.map(key => "--ck-" + key + ": " + palette[key][mode] + ";").join("");
};
var renderDarkModeAutoCSS = (lightPalette, darkPalette) => ":root {\n    " + lightPalette + "\n    color-scheme: light;\n  }\n  @media (prefers-color-scheme: dark) {\n    :root {\n      color-scheme: dark;\n      " + darkPalette + "\n    }\n  }";
var renderDarkModeBooleanCSS = (lightPalette, darkPalette) => ":root, :root[data-mode='light'] {\n    color-scheme: light;\n    " + lightPalette + "\n  }\n  :root[data-mode='dark'] {\n    color-scheme: dark;\n    " + darkPalette + "\n  }";
var BaseStyles = createGlobalStyle(["body{line-height:1.5;color:", ";}*,*:before,*:after{box-sizing:border-box;}:root{", " ", " ", "}", " .CK__Icon--medium{width:1rem;height:1rem;}.CK__Icon--large{width:1.5rem;height:1.5rem;}.CK__Modal_overflow-hidden{overflow:hidden;}"], paletteHelper("textPrimary"), _ref => {
  var {
    cssVariableBorderRadius
  } = _ref;
  return cssVariableBorderRadius;
}, _ref2 => {
  var {
    cssVariableShadows
  } = _ref2;
  return cssVariableShadows;
}, _ref3 => {
  var {
    cssVariableSpacing
  } = _ref3;
  return cssVariableSpacing;
}, _ref4 => {
  var {
    darkModeAuto,
    darkPalette,
    lightPalette
  } = _ref4;
  return darkModeAuto ? renderDarkModeAutoCSS(lightPalette, darkPalette) : renderDarkModeBooleanCSS(lightPalette, darkPalette);
});

/**
 * The Construct Kit wrapper component.
 *
 * @see [ConstructKit documentation](https://construct-kit.reainternal.net/components/web/core/construct-kit)
 */
var ConstructKit = _ref5 => {
  var {
    children,
    foundationsOverride = x => x,
    disableCssReset = false,
    darkMode = false
  } = _ref5;
  useEffect(() => {
    if (typeof darkMode === "boolean") document.documentElement.setAttribute("data-mode", darkMode ? "dark" : "light");
  }, [darkMode]);
  var theme = foundationsOverride(reaFoundations);
  var lightPalette = makePalette(theme.palette, "light");
  var darkPalette = makePalette(theme.palette, "dark");
  var effectivePalette = mapObject(theme.palette, k => "var(--ck-" + k + ")");
  var effectiveTheme = _extends({}, theme, {
    palette: effectivePalette
  });
  var cssVariableBorderRadius = makeCssVariables(theme.border.radius, "radius-");
  var cssVariableShadows = makeCssVariables({
    shadow: theme.shadow
  }, "");
  var cssVariableSpacing = makeCssVariables(theme.spacing, "spacing-");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: effectiveTheme
  }, /*#__PURE__*/React.createElement(ToastProvider, null, /*#__PURE__*/React.createElement(PortalProvider, null, !disableCssReset && /*#__PURE__*/React.createElement(CssReset, null), /*#__PURE__*/React.createElement(BaseStyles, {
    darkModeAuto: darkMode === "auto",
    lightPalette: lightPalette,
    darkPalette: darkPalette,
    cssVariableBorderRadius: cssVariableBorderRadius,
    cssVariableShadows: cssVariableShadows,
    cssVariableSpacing: cssVariableSpacing
  }), children))));
};
export default ConstructKit;